
import { CloseOutlined } from "@mui/icons-material";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography
} from "@mui/material";
import { useState } from "react";
import useAuth from "../../hooks/useAuth";

function ManageRechargeFilter({
    open, handleClose, searchParams, setSearchParams, handleClickSearch
}) {

    const { user } = useAuth();
    const [search, setSearch] = useState(searchParams);

    const handleChange = e => {
        const value = e.target.value;
        const name = e.target.name;
        setSearchParams({ ...search, [name]: value });
    };

    const onClickClear = () => {
        setSearchParams({
            name: "",
            billingTYpe: ""
        });
        handleClickSearch({
            billingTYpe: "",
            name: ""
        });
        handleClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="filter-dialog-title"
            fullWidth
        >
            <DialogTitle
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Typography variant="h5">Filter</Typography>
                <IconButton onClick={handleClose}>
                    <CloseOutlined />
                </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent >
                <Grid container spacing={2} justifyContent="space-between" alignItems="center">
                    <TextField
                        value={searchParams.name}
                        name="name"
                        label="Name"
                        fullWidth
                        placeholder="Enter Name"
                        onChange={handleChange}
                    />
                </Grid>
            </DialogContent>
            <DialogActions sx={{ padding: "1rem 1.5rem", justifyContent: "flex-end", gap: ".25rem" }}>
                <Button variant="outlined" color="error" onClick={() => onClickClear()} >
                    Clear
                </Button>
                <Button variant="contained" color="primary" onClick={() => handleClickSearch(searchParams)}
                    disabled={!searchParams.name}>
                    Search
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ManageRechargeFilter;
